'use client';

import { useEventBus, useJourney, useReferrer } from '@hc-frontend/core-ui';
import type {
  SendMetricEvent,
  SendMetricEventTarget,
} from '@hc-frontend/shells-shared';
import { useEffect } from 'react';

import type { PlateViewMetricProps } from './plate-view-metric.types';

export function PlateViewMetric({
  plateName,
  plateIndex,
  journeyEnd,
  product,
}: PlateViewMetricProps) {
  const eventBus = useEventBus();

  const { journeyId } = useJourney();

  const { referrer } = useReferrer();

  useEffect(() => {
    const { hostname, pathname, protocol } = window.location;
    const hostnameAndPath = `${protocol}//${hostname}${pathname}`;

    eventBus.publish<SendMetricEvent, SendMetricEventTarget>({
      id: 'page-view',
      topic: 'metric.client.message',
      source: hostnameAndPath,
      metric: {
        name: 'page-view',
        tags: {
          platform: 'apollo',
          plate_name: plateName,
          plate_index: plateIndex,
          journey_id: journeyId.toString(),
          journey_end: journeyEnd,
          product,
          referrer: referrer ?? document.referrer.split('?')[0],
        },
      },
    });
  }, [
    eventBus,
    product,
    plateName,
    plateIndex,
    journeyId,
    journeyEnd,
    referrer,
  ]);

  return null;
}
